import axios from 'axios'
import { paymentMethodUrl, getHeader } from '../config'

const state = {
  paymentMethodList: []
}

const mutations = {
  SET_PAYMENT_METHOD_LIST (state, obj) {
    state.paymentMethodList = obj
  }
}

const actions = {
  getPaymentMethodList: ({ commit }) => {
    axios.get(paymentMethodUrl, { headers: getHeader() })
      .then(response => {
        commit('SET_PAYMENT_METHOD_LIST', response.data.data)
      })
  }
}

export default {
  state, mutations, actions
}
